import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';

export interface ILoaderState {
  requests: Array<string>;
}

const initialState: ILoaderState = {
  requests: [],
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startLoading: (state: ILoaderState, action: PayloadAction<string>) => {
      state.requests.push(action.payload);
    },
    endLoading: (state: ILoaderState, action: PayloadAction<string>) => {
      state.requests = state.requests.filter((element) => element !== action.payload);
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoading, endLoading } = loaderSlice.actions;
// Other code such as selectors can use the imported `RootState` type
export const loader = (state: RootState) => state.loader.requests;

export default loaderSlice.reducer;
